<template>
    <div>
        <div class="prod-item" v-for="(book, index) in items" :key="index" @click="viewDetail(book)">
            <img class="cover" :src="book.cover" :alt="book.title">
            <div class="book-info">
                <div class="book-name" :title="book.title">{{book.title}}</div>
                <div class="book-desc" :title="book.introductionDesc">{{book.introductionDesc}}</div>
            </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>

</template>

<script>

    export default {
        name: "ProdBookItem",
        data() {
            return {
                loading: false
            }
        },
        props: {
            items: Array
        },
        methods: {
            viewDetail(item) {
                const preRouterName = this.$router.currentRoute.name
                const {pageIndex=1,keyword=''} = this.$router.currentRoute.query
                this.$router.push(`/service-center/detail?id=${item.id}&type=productManual&currentRoute=${preRouterName}&pageIndex=${pageIndex}&keyword=${keyword}`)
            }
        },
    }
</script>

<style scoped lang="scss">
    .prod-item {
        float: left;
        margin: 0 19px 0px 19px;
        overflow: hidden;
        text-align: center;
        width: 248px;
        height: 330px;
        .cover {
            width: 136px;
            height: 192px;
            margin: auto;
            cursor: pointer;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
        }

        .book-info {
            margin-top: 27px;
            overflow: hidden;
        }
        .book-desc{
            font-size: 12px;
            line-height: 17px;
            color: #6A6A6A;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .book-name {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #000000;
            width: 230px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 10px;
        }

        .download {
            float: right;
            width: 16px;
            height: 16px;
            font-family: icon-one;
            font-size: 16px;
            line-height: 1;
            color: #999990;
            cursor: pointer;
            margin-top: 13px;
            margin-right: 10px;
        }
    }
</style>
